// @flow
import * as React from 'react';
import NoFormSelect from 'esm-web-pro/components/forms/fields/NoFormSelect';
import { FormattedMessage, injectIntl } from 'react-intl';


type Props = {
    PoPLayer12: Object,
    value: ?string,
    onChange: Function,
    // intl: IntlShape,
};

const PortSelect = (props: Props) => {
    const {
        PoPLayer12, value, onChange,
    } = props;

    const choices = {};
    Object.values(PoPLayer12.optical_switch_ports).map((val) => val.sfp_port_number)
        .filter((curr, index, arr) => arr.indexOf(curr) === index)
        .forEach((val) => { choices[val] = val; });

    return (
        <NoFormSelect
            label={(
                <FormattedMessage id="connect-sfp-select" defaultMessage="Choose SFP" />
            )}
            choices={choices}
            value={value}
            onChange={onChange}
            required
        />
    );
};

export default injectIntl(PortSelect);
